/* eslint-disable react/forbid-elements */
import React, { useContext } from 'react';
import { appContext } from './appContext';
import { PanelWithoutForm } from './elements';

function SpinnerImage(props: { size: 'small' | 'large' }) {
    const currentAppContext = useContext(appContext.context);
    const { customerVersion } = currentAppContext.globalSettings;

    return <img src={`/assets/img/spinner-${customerVersion}.svg`} alt="loading" className={`spinner spinner-${props.size}`} />;
}

export function SpinnerContainer(props: { children: React.ReactNode }) {
    return <div className="spinner-container">{props.children}</div>;
}

export function PanelSpinner() {
    return (
        <PanelWithoutForm>
            <Spinner />
        </PanelWithoutForm>
    );
}

export function Spinner() {
    return (
        <SpinnerContainer>
            <SpinnerImage size="large" />
        </SpinnerContainer>
    );
}

export function SmallSpinner() {
    return <SpinnerImage size="small" />;
}
